import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Quote } from "lucide-react";

const formatDate = (value) => {
  if (!value) {
    return "";
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "";
  }
  return new Intl.DateTimeFormat("hu-HU", {
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(date);
};

export const GuestbookHighlights = ({ entries }) => {
  if (!entries?.length) {
    return null;
  }

  return (
    <section className="bg-sage/20" data-testid="guestbook-highlights-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div className="max-w-xl">
            <span className="overline text-teal">a vendégeim írták</span>
            <h2 className="mt-2 font-serif text-4xl md:text-5xl font-medium text-ink">
              Pár kedves szó
            </h2>
          </div>
          <Link
            to="/vendegkonyv"
            data-testid="guestbook-highlights-link"
            className="inline-flex items-center gap-2 text-sm font-medium text-ink hover:text-poppy
              transition-colors"
          >
            Minden bejegyzés
            <ArrowRight size={16} strokeWidth={1.8} />
          </Link>
        </div>
        <div className={`mt-10 grid gap-6 ${entries.length === 1 ? "md:grid-cols-1" : entries.length === 2 ? "md:grid-cols-2" : "md:grid-cols-3"}`}>
          {entries.map((entry) => (
            <article
              key={entry.entry_id}
              className="border-t-2 border-teal/40 pt-5"
              data-testid="guestbook-highlight-entry"
            >
              <Quote className="text-poppy" size={23} strokeWidth={1.5} />
              <p className="mt-4 font-serif text-2xl leading-relaxed text-ink whitespace-pre-wrap">
                „{entry.content}”
              </p>
              <div className="mt-5 text-xs text-inkmuted">
                {entry.name && (
                  <span className="font-medium text-ink" data-testid="guestbook-highlight-name">
                    {entry.name} · {" "}
                  </span>
                )}
                <time dateTime={entry.created_at} data-testid="guestbook-highlight-date">
                  {formatDate(entry.created_at)}
                </time>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};